import React, { useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { formateoBasico } from '../../../../utilidades/formateos';

const Tabla = ({ datosFiltrados, loading, globalFilterValue, setGlobalFilterValue }) => {
    const dt = useRef(null);

    // ── TEMPLATES ──────────────────────────────────────────────
    const velocidadTemplate = (rowData) => {
        const vel = rowData.VELOCIDAD;
        return (
            <Tag
                value={`${vel} km/h`}
                severity={vel >= 100 ? 'danger' : 'warning'}
                style={{ fontWeight: 700, fontSize: '0.85rem' }}
            />
        );
    };

    const clienteTemplate = (rowData) =>
        rowData.CLIENTE === 'SIN SERVICIO'
            ? <Tag value="SIN SERVICIO" severity="secondary" />
            : <span>{rowData.CLIENTE}</span>;

    const rutaTemplate = (rowData) =>
        rowData.RUTA === 'SIN SERVICIO'
            ? <Tag value="SIN SERVICIO" severity="secondary" />
            : <span>{rowData.RUTA}</span>;

    const fechaTemplate = (rowData) => {
        if (!rowData.FECHA) return null;
        return formateoBasico(rowData.FECHA) + ' ' + rowData.HORA;
    };

    const coordenadasTemplate = (rowData) => {
        if (!rowData.LATITUD || !rowData.LONGITUD)
            return <span className="ev-sin-coords">—</span>;
        return (
            <a
                href={`https://maps.google.com/?q=${rowData.LATITUD},${rowData.LONGITUD}`}
                target="_blank"
                rel="noreferrer"
                className="ev-link-mapa"
            >
                <i className="pi pi-map-marker" /> Ver mapa
            </a>
        );
    };

    // ── HEADER CON FILTRO GLOBAL ────────────────────────────────
    const header = (
        <div className="ev-table-header">
            <span className="ev-table-title">
                <i className="pi pi-car" /> Detalle de Excesos
            </span>
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText
                    value={globalFilterValue}
                    onChange={(e) => setGlobalFilterValue(e.target.value)}
                    placeholder="Buscar..."
                    className="ev-global-filter"
                />
            </IconField>
        </div>
    );

    return (
        <DataTable
            ref={dt}
            value={datosFiltrados}
            loading={loading}
            header={header}
            globalFilter={globalFilterValue}
            emptyMessage="Sin registros"
            stripedRows
            resizableColumns
            columnResizeMode="expand"
            scrollable
            scrollHeight="calc(100vh - 300px)"
            virtualScrollerOptions={{ itemSize: 40 }}
            size="small"
            className="ev-datatable"
        >
            <Column field="ID" header="ID" sortable style={{ minWidth: '5rem' }} />
            <Column field="FECHA" header="Fecha" body={fechaTemplate} sortable style={{ minWidth: '10rem' }} />
            <Column field="ID_UNIDAD" header="Unidad" sortable style={{ minWidth: '6rem' }} />
            <Column field="OPERADOR" header="Operador" sortable style={{ minWidth: '12rem' }} />
            <Column field="TIPO_UNIDAD" header="Tipo Unidad" sortable style={{ minWidth: '9rem' }} />
            <Column field="CLIENTE" header="Cliente" body={clienteTemplate} sortable style={{ minWidth: '12rem' }} />
            <Column field="RUTA" header="Ruta" body={rutaTemplate} sortable style={{ minWidth: '12rem' }} />
            <Column field="VELOCIDAD" header="Velocidad" body={velocidadTemplate} sortable style={{ minWidth: '8rem' }} />
            <Column field="DESCRIPCION" header="Descripción" style={{ minWidth: '18rem' }} />
            <Column header="Ubicación" body={coordenadasTemplate} style={{ minWidth: '8rem' }} />
        </DataTable>
    );
};

export default Tabla;
